import React, { Component } from "react";
import { NavLink,Link } from "react-router-dom";
import "./header.scss";


export default class Header extends Component {
	constructor() {
      super();
	this.state = {
          scrollActive: 'hidden',
          mobileMenuActive: 'hidden'
      };
  }
	showMenu = () =>{
		if(this.state.mobileMenuActive === 'active'){
			this.setState({mobileMenuActive: 'hidden'})
		} else{
		    this.setState({mobileMenuActive: 'active'})
		}

	}
	render() {
		return (
			<div>
				<div id="header" className="top-bar">
					<div className={this.state.scrollActive}>
						<div className="logo-container">
							<NavLink exact to="/" >
								<img alt="" className="logo" src="/images/logo.png" />
							</NavLink>
						</div>
						<nav>
							<div className="hide-for-small">
								<NavLink to="/event">Event</NavLink>
								<NavLink to="/get-ready">Get Ready</NavLink>
								<div className="nav-item-dropdown">
									<NavLink to="/stay-with-us" isActive={(_, location) => ['/stay-with-us', '/camping', '/lodging'].includes(location.pathname)}>
										Stay With Us
									</NavLink>
									<div className="nav-dropdown">
										<NavLink to="/camping">Camping</NavLink>
										<NavLink to="/lodging">Lodging</NavLink>
									</div>
								</div>
								<NavLink to="/clinics">Clinics</NavLink>
								<NavLink to="/sponsors">Sponsors</NavLink>
								<NavLink to="/story">About Us</NavLink>
								<NavLink to="/merch">Merch</NavLink>
								<NavLink to="/peak-purpose">Peak Purpose</NavLink>
								
								{/* Temporary: restore Register CTA when registration reopens */}
								<NavLink className="header-register-cta--hidden" style={{opacity:1}} to="/register">
									<div className="button header-cta">Register</div>
								</NavLink>
							</div>
							<div id="mobile-menu-icon" className="show-for-small" onClick={this.showMenu}>
								<img alt="" className="mobile-menu-icon-light full-width" src="/images/menu-light.png" />
								<img alt="" className="mobile-menu-icon-dark full-width" src="/images/menu-dark.png" />
							</div>
						</nav>
						<div className="top-bar-background"></div>
					</div>
					<div className="coupon-container"><Link to="/register">{'$50 off before 6/24 with code '}<b>{'EARLYBIRD50'}</b></Link></div>
				</div>
				<div id="mobile-menu" className={this.state.mobileMenuActive} style={{backgroundImage:"url(./images/topo-texture.png)"}}>
					<div className="top-bar mobile-menu-top-bar">
						<div className="logo-container">
						</div>
						<nav>
							<div id="mobile-menu-icon" className="show-for-small" onClick={this.showMenu}>
								<img alt="" className="mobile-menu-icon-light full-width" src="/images/close-icon.png" />
							</div>
						</nav>
						<div className="coupon-container"><Link to="/register">{'$50 off before 6/24 with code '}<b>{'EARLYBIRD50'}</b></Link></div>
					</div>
					<div className="mobile-menu-content">
						<NavLink exact to="/" onClick={this.showMenu} style={{paddingTop:0, marginTop:0}}>
							<img alt="" className="logo logo-light shadow mobile-menu-logo" src="images/mobile-logo.png" />
						</NavLink>
						<NavLink to="/event" onClick={this.showMenu}>Event</NavLink>
						<NavLink to="/get-ready" onClick={this.showMenu}>Get Ready</NavLink>
						<NavLink to="/stay-with-us" onClick={this.showMenu}>Stay With Us</NavLink>
						<NavLink to="/clinics" onClick={this.showMenu}>Clinics</NavLink>
						<NavLink to="/camping" onClick={this.showMenu}>Camping</NavLink>
						<NavLink to="/lodging" onClick={this.showMenu}>Lodging</NavLink>
						<NavLink to="/mission" onClick={this.showMenu}>Mission</NavLink>
						<NavLink to="/story" onClick={this.showMenu}>About Us</NavLink>
						<NavLink to="/merch" onClick={this.showMenu}>Merch</NavLink>
						<NavLink to="/peak-purpose" onClick={this.showMenu}>Peak Purpose</NavLink>
						<NavLink to="/sponsors" onClick={this.showMenu}>Sponsors</NavLink>
					</div>
					<div className="mobile-menu-footer header-register-cta--hidden">
						<NavLink to="/register" style={{textDecoration:'none'}} onClick={this.showMenu}>
							<div className="header-cta button">Register</div>
						</NavLink>
					</div>
				</div>
			</div>
		)
	}
}
